import React, {useContext} from 'react';
import { useHistory } from 'react-router';
import SimpleContext from '../context/SimpleContext';
import CATEGORY_TWO from './Category_Two';


const Categories_Two = () => {

    const context = useContext(SimpleContext);
    const history = useHistory();

    return ( 
        <div className="productsmain">    
            <div className="otherPagesHeader">
                <div className="barbuttonn">
                    <img src="images/Api.jpg" className="apiLogoHeaders" alt=""/>
                </div>
                <div className="headersNames">
                    <p style={{margin:"0"}}>{context.catNameHeader}</p>
                </div>
                <div className="searchbtnn" onClick={()=>history.go(-1)}>
                    <i className="fa fa-chevron-left" />
                </div>
            </div>
            <div className="cat_baners_div">

                {
                    context.category_two.length?
                    context.category_two.map(cat2 => 
                        <div className="cat2" key={cat2.ID}>
                            <CATEGORY_TWO 
                            slug={cat2.ImgUrl}
                            isend={cat2.IsEnd}
                            gname={cat2.GroupName}
                            catL3= {cat2.ID}
                            />

                        </div>
                            
                    ):null
                }
                
            </div>
        </div>

     );
}
 
export default Categories_Two;